import { useEffect, React, useContext, useCallback, useMemo, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import ScrollToTop from 'react-scroll-to-top';

import './styles.css';
//import 'react-toastify/dist/ReactToastify.css';
import 'react-toastify/dist/ReactToastify.min.css';

import { BarTop } from '../../components/BarTop';
import { Banner } from '../../components/Banner';
//import { Categorias } from '../../components/Categorias';

import { SacolaBar } from '../../components/SacolaBar';
import { Rodape } from '../../components/Rodape';
import { ListaProdutos } from '../../components/ListaProdutos';
import { ToastContainer } from 'react-toastify';
//import { Button } from '../../components/Button';
import { GlobalContext } from '../../contexts/HomeContext';
import {
  GetStatusLoja,
  //ScrollToTop,
  GetUsuario,
  SaveUser,
  UpdateItensCount,
  IniciaGoogleMaps,
  ValidDateTimeBasket,
  CreateElementFingerPrint,
  isObjectEmpty,
  doRedirectUrl,
  setStripePromise,
} from '../../utils/utils';
import { initializeGoogleAnalytics, initializeMetaPixel } from '../../utils/tracking';
import { GetDadosApp, GetDadosEmpresaConfig, GetIpPublic, Logar } from '../../utils/api/api';
import { useSocketio } from '../../contexts/SocketioContext';
import { Modal } from '../../components/Modal';
// import MenuCategorias from '../../components/MenuCategorias';
import MenuCategorias from '../../components/MenuCategorias';
import ScrollIcon from '../../components/svg';
//import MenuHeader from '../../components/MenuHeader';
//import { Agendamento } from '../../components/Agendamento';

let isLoading = false;

export const Home = () => {
  const { dadosApp, setDadosApp, statusLoja, setStatusLoja, setUser, setSacola, setEnderecos } =
    useContext(GlobalContext);
  const { socketResponse, socketConnect } = useSocketio();
  const [modalOpcoes, setModalOpcoes] = useState(false);
  const params = useParams();
  const navigate = useNavigate();
  const search = useLocation().search;

  IniciaGoogleMaps();

  const mesa = new URLSearchParams(search).get('mesa');
  const PreCadastro = new URLSearchParams(search).get('PreCadastro');
  const setor_cardapio = new URLSearchParams(search).get('setor_cardapio');
  const setor_trabalho = new URLSearchParams(search).get('setor_trabalho');
  const solicitacao = new URLSearchParams(search).get('solicitacao');
  const portaria = new URLSearchParams(search).get('portaria');
  const posicao = new URLSearchParams(search).get('posicao');
  const show = new URLSearchParams(search).get('show'); // exibir o menu após realizar o pedido?
  const selected = new URLSearchParams(search).get('selected');
  const comanda = new URLSearchParams(search).get('comanda'); // parametro para o módulo auto atendimento Cartão
  const modulo = new URLSearchParams(search).get('modulo');
  const cardapioDigital = new URLSearchParams(search).get('cardapio_digital');

  // URL DO PRE-CADASTRO
  //'http://localhost:3002/loja/2?PreCadastro=true'

  //http://localhost:3000/loja/2?mesa=7&posicao=2&setor_cardapio=salao&setor_trabalho=salao&solicitacao=0
  //http://localhost:3000/loja/2?mesa=789&posicao=2&setor_cardapio=salao&setor_trabalho=salao&solicitacao=0&portaria=true

  // http://localhost:3002/loja/2?mesa=707&posicao=2&setor_cardapio=salao&setor_trabalho=salao&solicitacao=0
  // http://localhost:3002/loja/2?mesa=707&posicao=2&setor_cardapio=salao&setor_trabalho=salao&solicitacao=0&modulo=BALCAO

  let idLoja = params.loja;
  if (isNaN(idLoja)) {
    // se não pegou a loja pela rota padrão ex: /loja/9833, então verifica via query ex: loja?loja=9833
    idLoja = new URLSearchParams(search).get('loja');
  }

  // este IF é somente enquanto em desenvolvimento
  if (idLoja === null) {
    idLoja = '2'; //9833 butoh 2043 arcos;
  } // este IF é somente enquanto em desenvolvimento

  /*
    poder pagar sem que o usuário estaja cadastrado
      15055
      15788 - fresto hebraica
      15006 - fresto
      10515 - fresto
      10963 - loja do maicon
      10417 - cafe sujinho
      2 - garçom web
  */
  // antiga regra que foi retirada para ser controlada diretamente pela loja via configuração no painel, pois a regra de negócio estava muito acoplada ao ID da loja,
  // e isso não é flexível para o cliente final, eu tinha que ficar atualizando o site sempre que um cliente novo queria essa funcionalidade, agora a própria loja pode controlar isso de forma simples e rápida, sem depender de mim
  // const idsAceitaPagamentoSemUsuario = ['15788', '15006', '10515', '10963', '10417', '2'];
  // dadosApp.aceitaPagamentoSemUsuario = idsAceitaPagamentoSemUsuario.includes(idLoja) && dadosApp.TipoApp !== 'DELIVERY';

  const qs = useMemo(() => {
    /* HOJE OS MÓDULOS ESTÃO DEFINIDOS ASSIM

      tiver solicitacao=0 -> MESA
      tiver comanda = true -> CARTAO
      tiver modulo = BALCAO -> BALCAO
      se não tiver nenhum destes -> DELIVERY

      tentar padronizar para ficar apenas -> modulo
    */

    let _modulo = 'MESA';
    if (solicitacao === 0 && !comanda && !modulo) _modulo = 'MESA';
    if (comanda) _modulo = 'CARTAO';
    if (modulo === 'BALCAO') _modulo = 'BALCAO';
    if (portaria) _modulo = 'MESA';

    return {
      Idloja: idLoja,
      mesa: mesa,
      comanda: 0,
      posicao: posicao || 0,
      Origem: 'USUARIO',
      Destino: 'SRVCX',
      SetorCardapio: setor_cardapio || '',
      SetorTrabalho: setor_trabalho || '',
      Solicitacao: solicitacao,
      cardapioDigital: cardapioDigital,
      Portaria: portaria,
      Modulo: _modulo,
      Body: JSON.stringify({
        Idloja: idLoja,
        mesa: mesa,
        comanda: 0,
        posicao: posicao || 0,
        Origem: 'USUARIO',
        Destino: 'SRVCX',
        SetorCardapio: setor_cardapio || '',
        SetorTrabalho: setor_trabalho || '',
        Solicitacao: solicitacao,
        Portaria: portaria,
        Modulo: _modulo,
      }),
    };
  }, [idLoja, mesa, posicao, modulo, setor_cardapio, setor_trabalho, comanda, solicitacao, portaria, cardapioDigital]);

  //qs.Body = JSON.stringify(qs);

  const handleAutoLogin = useCallback(
    async (idloja) => {
      const usuario = GetUsuario(idloja);
      if (!usuario?.ativo) return;
      const response = await Logar(usuario);
      if (response.data.Retorno.status == 0) {
        usuario.ativo = response.data.Usuario.ativo;
        usuario.cpf = response.data.Usuario.cpf;
        usuario.sexo = response.data.Usuario.sexo;
        SaveUser(idloja, usuario, setUser);
        setEnderecos(response.data.Enderecos);
      }
    },
    [setEnderecos, setUser],
  );

  // const GerarGuidSessao = useCallback(async () => {
  //   if (isNaN(idLoja)) {
  //     history.push('/loja/Page404?message=' + 'Loja não encontrada');
  //     return;
  //   }

  //   const obj = { operadora: 10, empresa: { idLoja: idLoja }, ParametroConsulta: 'gerar_sessao' };
  //   const response = await GerarGuidSessaoPagSeguro(obj);
  //   if (response.data.status == 'ok') {
  //     setDadosApp((prevState) => {
  //       return {
  //         ...prevState,
  //         GuidSessao: response.data.retornoMensagem,
  //       };
  //     });
  //     return response.data.retornoMensagem;
  //   }
  // }, [history, idLoja, setDadosApp]);

  // const handleSenderHashPagSeguro = useCallback(async () => {
  //   var exist = window.PagSeguroDirectPayment;
  //   if (!exist) {
  //     if (dadosApp.Empresa.Config?.cartao_ambiente?.replace('HOMOLOGAÇÃO', 'HOMOLOGACAO') === 'HOMOLOGACAO') {
  //       AddLibrary('https://stc.sandbox.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.directpayment.js');
  //     } else AddLibrary('https://stc.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.directpayment.js');

  //     if (modulo === 'BALCAO') {
  //       dadosApp.GuidSessao = await GerarGuidSessao();
  //     }

  //     // aguarda 4 segundos para garantir que a biblioteca já foi importada
  //     setTimeout(() => {
  //       window.PagSeguroDirectPayment.setSessionId(dadosApp.GuidSessao);
  //     }, 4000);

  //     // aguarda 7 segundos para garantir que a biblioteca já foi importada
  //     setTimeout(() => {
  //       window.PagSeguroDirectPayment.onSenderHashReady(function (response) {
  //         if (response) {
  //           if (response.status == 'error') {
  //             return false;
  //           }
  //           setDadosApp((prevState) => {
  //             return {
  //               ...prevState,
  //               sH: response.senderHash,
  //             };
  //           });
  //         }
  //       });
  //     }, 8000);
  //   }
  // }, [dadosApp, setDadosApp, modulo, GerarGuidSessao]);

  const handleGetDadosApp = useCallback(async () => {
    if (isNaN(idLoja)) {
      navigate('/loja/Page404?message=' + 'Loja não encontrada');
      return;
    }

    if (isLoading) return; // pra previnir que vá duas vezes no servidor a toa
    isLoading = true;
    // const result = await redirectUrl; // verifica se a URL já é a nova: Garçom Web

    //console.log('getDadosENtrou');

    //const obj = { IdLoja: idLoja, LocalPedido: '' }; //9833 butoh //2043 arcos
    const obj = { IdLoja: idLoja, LocalPedido: cardapioDigital === 'true' ? 'CARDAPIO DIGITAL' : '' }; //9833 butoh //2043 arcos

    const response = await GetDadosApp(obj);
    if (response.data.Retorno.status == 0) {
      let dados = response.data;
      //console.log('response', dados);
      if (dados.Retorno.status === 0) {
        if (dados.Cardapio.Categorias == null) {
          navigate('/loja/Page404?message=' + 'Erro: Cardápio nulo');
          return;
        }
        // aceita_pagamento_sem_cadastro

        const _tipoApp = solicitacao === null ? 'DELIVERY' : 'MESA';
        setDadosApp((prevState) => {
          return {
            ...prevState,
            IdLoja: dados.Empresa.Empresa.codigo_sistema,
            Empresa: dados.Empresa,
            Cardapio: {
              Adicionais: dados.Cardapio.Adicionais,
              Categorias: dados.Cardapio.Categorias.sort(function (a, b) {
                if (a.ordem_app > b.ordem_app) {
                  return 1;
                }
                if (a.ordem_app < b.ordem_app) {
                  return -1;
                }
                // a must be equal to b
                return 0;
              }),
              Combos: dados.Cardapio.Combos,
              Obrigatorios: dados.Cardapio.Obrigatorios,
              Pizzas: dados.Cardapio.Pizzas || [],
              Produtos: dados.Cardapio.Produtos.sort(function (a, b) {
                if (a.ordem_app > b.ordem_app) {
                  return 1;
                }
                if (a.ordem_app < b.ordem_app) {
                  return -1;
                }
                // a must be equal to b
                return 0;
              }),
              MultPreco: dados.Cardapio.MultPreco,
              retorno: dados.Cardapio.retorno,
            },
            DiaSemana: dados.DiaSemana,
            FormasPagamento: dados.FormasPagamento,
            TabelaTaxaKm: dados.TabelaTaxaKm,
            GuidSessao: dados.GuidSessao,
            TipoApp: _tipoApp, //solicitacao === null ? 'DELIVERY' : 'MESA',
            Mesa: mesa === null ? 0 : mesa,
            portaria: comanda ? true : portaria === null ? false : JSON.parse(portaria),
            Qs: qs,
            //portaria: portaria === null ? false : JSON.parse(portaria),
          };
        });

        //const selected = new URLSearchParams(search).get('selected');
        if (PreCadastro) {
          isLoading = false;
          navigate('/loja/PreCadastro');
          return;
        }

        if (dados.Empresa.Mult.length > 1 && selected === null && solicitacao === null && !cardapioDigital) {
          isLoading = false;
          navigate('/loja/Cardapio');
          return;
        }

        GetStatusLoja(dados, statusLoja, setStatusLoja);
        handleAutoLogin(dados.Empresa.Empresa.codigo_sistema);
        UpdateItensCount(dados.Empresa.Empresa.codigo_sistema, setSacola);
        ValidDateTimeBasket(dados.Empresa.Empresa.codigo_sistema, setSacola);
        if (dados.Empresa.Config.ant_fraude == 1)
          CreateElementFingerPrint(dados.Empresa.Config.cartao_SELLERID, dados.GuidSessao);

        if (_tipoApp === 'DELIVERY' && cardapioDigital !== 'true') {
          const url =
            '/loja/' +
            //dados.Empresa.Empresa.tipo_app.toLowerCase() +
            _tipoApp.toLowerCase() +
            '/' +
            idLoja +
            '/' +
            dados.Empresa.Empresa.fantasia.replace(' ', '-').toLowerCase();
          navigate(url);
          isLoading = false;
        }
      } else {
        navigate('/loja/Page404?message=' + dados.Retorno.msg);
      }
    } else {
      navigate('/loja/Page404?message=' + response.data.Retorno.msg);
      //history.push('/loja/error/Page404?message=' + response.data.Retorno.msg);
    }
  }, []);

  // obtem as configuracoes do provedor
  const handleGetDadosEmpresaConfig = useCallback(async (_idLoja, _empresa, _setDadosApp) => {
    const response = await GetDadosEmpresaConfig(_idLoja);

    if (response?.data?.length > 0) {
      const _config = response.data[0];

      _empresa.Config.pagamento_online = _config.pagamento_online;
      _empresa.Config.cartao_operadora = _config.cartao_operadora;

      // stripe
      _empresa.Config.stripe = _config.stripe;
      _empresa.Config.stripe_formulario = _config.stripe_formulario;
      _empresa.Config.stripe_token_publico = _config.stripe_token_publico;
      _empresa.Config.stripe_token_secreto = _config.stripe_token_secreto;

      // pix
      _empresa.Config.pix_habilitado = _config.pix_habilitado;
      _empresa.Config.pix_merchant_id = _config.pix_merchant_id;
      _empresa.Config.pix_merchant_key = _config.pix_merchant_key;
      _empresa.Config.pix_operadora = _config.pix_operadora;
      _empresa.Config.pix_seller_id = _config.pix_seller_id;
      _empresa.Config.pix_token = _config.pix_token;

      // reatreamento
      //  const { google_analytics, meta_pixel, aceita_pagamento_sem_cadastro } = dadosApp.Empresa.Config;
      _empresa.Config.google_analytics = _config.google_analytics;
      _empresa.Config.meta_pixel = _config.meta_pixel;

      // Qlub
      _empresa.Config.qlub = _config.qlub;

      // pagamento sem cadastro
      // _empresa.aceita_pagamento_sem_cadastro = _config.aceita_pagamento_sem_cadastro === 1;

      _setDadosApp((prevState) => {
        return {
          ...prevState,
          // define se aceita pagamento sem cadastro, somente para auto atendimento (BALCAO e MESA), para DELIVERY o cadastro é obrigatório
          aceitaPagamentoSemUsuario: _config.aceita_pagamento_sem_cadastro,
          Empresa: _empresa,
        };
      });
    }
  }, []);

  const handleResposta = useCallback(
    async (data, _qs) => {
      if (data) {
        switch (data.Solicitacao) {
          case '0': // STATUS_MESA - GETDADOS
            if (data.readed) return;
            if (data.Status === 0) {
              const dados = JSON.parse(data.Body);

              if (dados.Retorno[0].retorno === 1) {
                navigate('/loja/Page404?message=' + dados.Retorno[0].msgerror);
                return;
              }

              //const _tipoApp = solicitacao === null ? 'DELIVERY' : 'MESA';
              const _tipoApp = modulo === 'BALCAO' ? 'BALCAO' : solicitacao === null ? 'DELIVERY' : 'MESA';
              const _empresa = {
                Empresa: dados.Empresa[0].Empresa[0],
                Config: dados.Empresa[0].Config[0],
                Mult: [],
              };

              if (_tipoApp === 'BALCAO') {
                _empresa.Config.pagamento_online = 1;
                _empresa.Config.cartao_operadora = 'STONE';
                _empresa.Config.cartao_ambiente = 'PRODUCAO';
              }

              // redireciona para o cardápio externo (PDF) caso o auto atendimento esteja desativado
              // if (!dados.Empresa[0]?.Config[0]?.auto_atendimento_mesa &&
              //   _empresa.Config.cardapio_externo === 1 &&
              //   _empresa.Config.cardapio_caminho?.includes('.pdf')) {
              //   navigate(_empresa.Config.cardapio_caminho, { replace: true });
              //   return;
              // }

              if (
                !dados.Empresa[0]?.Config[0]?.auto_atendimento_mesa &&
                _empresa.Config.cardapio_externo === 1 &&
                _empresa.Config.cardapio_caminho?.includes('.pdf')
              ) {
                window.location.replace(_empresa.Config.cardapio_caminho);
                // window.location.replace("https://e3e70c22-c9da-4ea7-b9ec-be812de521be.filesusr.com/ugd/2d22fa_5a495e810ce848138d68c82e74e36eef.pdf");
                // navigate(_empresa.Config.cardapio_caminho, { replace: true });
                return;
              }

              _empresa.Config.auto_atendimento_mesa = dados.Empresa[0]?.Config[0]?.auto_atendimento_mesa | true;

              _empresa.Empresa.tipo_app = _tipoApp;

              GetStatusLoja({ Empresa: _empresa }, statusLoja, setStatusLoja);
              if (_tipoApp !== 'BALCAO') setModalOpcoes(true);

              setDadosApp((prevState) => {
                return {
                  ...prevState,
                  IdLoja: dados.Empresa[0].Empresa[0].codigo_sistema,
                  Empresa: _empresa,
                  Cardapio: {
                    Adicionais: dados.Cardapio[0].Adicionais,
                    Categorias: dados.Cardapio[0].Categorias.sort(function (a, b) {
                      if (a.ordem_app > b.ordem_app) {
                        return 1;
                      }
                      if (a.ordem_app < b.ordem_app) {
                        return -1;
                      }
                      // a must be equal to b
                      return 0;
                    }),
                    Combos: dados.Cardapio[0].Combos,
                    Obrigatorios: dados.Cardapio[0].Obrigatorios,
                    Pizzas: dados.Cardapio[0].Pizzas || [],
                    Produtos: dados.Cardapio[0].Produtos.sort(function (a, b) {
                      if (a.ordem_app > b.ordem_app) {
                        return 1;
                      }
                      if (a.ordem_app < b.ordem_app) {
                        return -1;
                      }
                      // a must be equal to b
                      return 0;
                    }),
                    MultPreco: dados.Cardapio[0].MultPreco, // fazer na api pdv
                    retorno: dados.Cardapio[0].Retorno[0],
                  },
                  //DiaSemana: dados.DiaSemana,
                  //FormasPagamento: dados.FormasPagamento,
                  //TabelaTaxaKm: dados.TabelaTaxaKm,
                  GuidSessao: dados.GuidSessao[0].GuidSessao,
                  TipoApp: _tipoApp,
                  Mesa: mesa === null ? 0 : mesa,
                  portaria: comanda ? true : portaria === null ? false : JSON.parse(portaria),
                  //portaria: portaria === null ? false : JSON.parse(portaria),
                  Qs: _qs,
                  Url: window.location.href
                    .replace('http://localhost:3000', '')
                    .replace('http://localhost:3001', '')
                    .replace('http://localhost:3002', '')
                    .replace('https://geneseweb.com.br', '')
                    .replace('https://www.geneseweb.com.br', '')
                    .replace('https://garcomweb.com.br', '')
                    .replace('https://www.garcomweb.com.br', ''),
                };
              });

              handleAutoLogin(dados.Empresa[0].Empresa[0].codigo_sistema);
              UpdateItensCount(dados.Empresa[0].Empresa[0].codigo_sistema, setSacola);
              ValidDateTimeBasket(dados.Empresa[0].Empresa[0].codigo_sistema, setSacola);
              // ir no provedor obter os demais dados de configuracao
              handleGetDadosEmpresaConfig(dados.Empresa[0].Empresa[0].codigo_sistema, _empresa, setDadosApp);
            } else {
              navigate('/loja/Page404?message=' + data.Body);
            }
            break;
          case '1': // FINALIZAR_PEDIDO
          case '2': // CONFERENCIA
          case '3': // PAGAMENTO
          case '5': // PAGAMENTO
          case '8': // VALIDA PRODUTOS BALCAO
            //case '4': // STATUS_AUTO_ATENDIMENTO
            break;

          default:
            navigate('/loja/Page404?message=Solicitação Não Homologada');
            break;
        }

        // if (data.Solicitacao !== '0') {
        //   if (data.Solicitacao !== '1') {
        //     if (data.Solicitacao !== '2') {
        //       if (data.Solicitacao !== '3') {
        //         if (data.Solicitacao !== '4') {
        //           history.push('/loja/Page404?message=Solicitação Não Homologada');
        //         }
        //       }
        //     }
        //   }
        //   return;
        // }

        // if (data.readed) return;
        // if (data.Status === 0) {
        //   const dados = JSON.parse(data.Body);

        //   if (dados.Retorno[0].retorno === 1) {
        //     history.push('/loja/Page404?message=' + dados.Retorno[0].msgerror);
        //     return;
        //   }

        //   const _tipoApp = solicitacao === null ? 'DELIVERY' : 'MESA';
        //   const _empresa = {
        //     Empresa: dados.Empresa[0].Empresa[0],
        //     Config: dados.Empresa[0].Config[0],
        //     Mult: [],
        //   };

        //   _empresa.Empresa.tipo_app = _tipoApp;

        //   GetStatusLoja({ Empresa: _empresa }, statusLoja, setStatusLoja);
        //   setModalOpcoes(true);
        //   setDadosApp((prevState) => {
        //     return {
        //       ...prevState,
        //       IdLoja: dados.Empresa[0].Empresa[0].codigo_sistema,
        //       Empresa: _empresa,
        //       Cardapio: {
        //         Adicionais: dados.Cardapio[0].Adicionais,
        //         Categorias: dados.Cardapio[0].Categorias.sort(function (a, b) {
        //           if (a.ordem_app > b.ordem_app) {
        //             return 1;
        //           }
        //           if (a.ordem_app < b.ordem_app) {
        //             return -1;
        //           }
        //           // a must be equal to b
        //           return 0;
        //         }),
        //         Combos: dados.Cardapio[0].Combos,
        //         Obrigatorios: dados.Cardapio[0].Obrigatorios,
        //         Produtos: dados.Cardapio[0].Produtos.sort(function (a, b) {
        //           if (a.ordem_app > b.ordem_app) {
        //             return 1;
        //           }
        //           if (a.ordem_app < b.ordem_app) {
        //             return -1;
        //           }
        //           // a must be equal to b
        //           return 0;
        //         }),
        //         MultPreco: dados.Cardapio[0].MultPreco, // fazer na api pdv
        //         retorno: dados.Cardapio[0].Retorno[0],
        //       },
        //       //DiaSemana: dados.DiaSemana,
        //       //FormasPagamento: dados.FormasPagamento,
        //       //TabelaTaxaKm: dados.TabelaTaxaKm,
        //       GuidSessao: dados.GuidSessao[0].GuidSessao,
        //       TipoApp: _tipoApp,
        //       Mesa: mesa === null ? 0 : mesa,
        //       portaria: comanda ? true : portaria === null ? false : JSON.parse(portaria),
        //       //portaria: portaria === null ? false : JSON.parse(portaria),
        //       Qs: _qs,
        //       Url: window.location.href
        //         .replace('http://localhost:3000', '')
        //         .replace('http://localhost:3001', '')
        //         .replace('http://localhost:3002', '')
        //         .replace('https://geneseweb.com.br', '')
        //         .replace('https://www.geneseweb.com.br', ''),
        //     };
        //   });
        //   UpdateItensCount(dados.Empresa[0].Empresa[0].codigo_sistema, setSacola);
        //   ValidDateTimeBasket(dados.Empresa[0].Empresa[0].codigo_sistema, setSacola);
        // } else {
        //   history.push('/loja/Page404?message=' + data.Body);
        // }
      } else {
        navigate('/loja/Page404?message=Erro ao obter resposta');
      }
      data.readed = true;
    },
    [
      navigate,
      mesa,
      setDadosApp,
      setSacola,
      solicitacao,
      portaria,
      comanda,
      statusLoja,
      setStatusLoja,
      handleAutoLogin,
      modulo,
      handleGetDadosEmpresaConfig,
    ],
  );

  const GetIP = useCallback(async () => {
    const result = await GetIpPublic();
    setUser((prevState) => {
      return {
        ...prevState,
        geolocation: result.data,
      };
    });
  }, [setUser]);

  // OBSERVA AS RESPOSTA DAS REQUISIÇÕES DE GETDADOS
  useEffect(() => {
    if (!isObjectEmpty(socketResponse)) {
      handleResposta(socketResponse, qs);
    }
    return () => socketResponse;
  }, [socketResponse, qs, handleResposta]);

  useEffect(() => {
    doRedirectUrl();
  }, []);

  useEffect(() => {
    if (solicitacao !== null) {
      socketConnect(qs);
    } else handleGetDadosApp();
  }, [handleGetDadosApp, qs, socketConnect, solicitacao]);

  useEffect(() => {
    if (show) {
      //setModalOpcoes(true);
      if (dadosApp.TipoApp !== 'BALCAO') setModalOpcoes(true);
      navigate(dadosApp.Url, { replace: true });
    }
  }, [show, navigate, dadosApp.Url, dadosApp.TipoApp]);

  useEffect(() => {
    GetIP();
  }, [GetIP]);

  useEffect(() => {
    if (dadosApp?.Empresa?.Config?.stripe === 1) setStripePromise(dadosApp.Empresa.Config.stripe_token_publico);
  }, [dadosApp]);

  // Initialize Google Analytics and Meta Pixel when company data is loaded
  useEffect(() => {
    if (dadosApp?.Empresa?.Config) {
      const { google_analytics, meta_pixel } = dadosApp.Empresa.Config;

      // Initialize Google Analytics if available
      if (google_analytics) {
        initializeGoogleAnalytics(google_analytics);
      }

      // Initialize Meta Pixel if available
      if (meta_pixel) {
        initializeMetaPixel(meta_pixel);
      }
    }
  }, [dadosApp]);
  // }, [dadosApp?.Empresa?.Config?.google_analytics, dadosApp?.Empresa?.Config?.meta_pixel]);

  // se for pagamento via PagSeguro
  // useEffect(() => {
  //   if (dadosApp.IdLoja > 0) {
  //     if (
  //       dadosApp.Empresa?.Config?.pagamento_online === 1 &&
  //       dadosApp.Empresa?.Config?.cartao_operadora === 'PAGSEGURO'
  //     ) {
  //       handleSenderHashPagSeguro();
  //     }
  //   }
  // }, [dadosApp, setDadosApp, handleSenderHashPagSeguro]);

  useEffect(() => {
    if (selected && parseFloat(dadosApp.Empresa.Empresa.codigo_sistema) !== parseFloat(idLoja)) {
      setDadosApp({
        IdLoja: 0,
        Empresa: {
          Area: {},
          Config: {},
          Empresa: {},
          Mult: [],
        },
        Cardapio: {
          Adicionais: [],
          Categorias: [],
          Combos: [],
          Obrigatorios: [],
          Pizzas: [],
          Produtos: [],
          MultPreco: [],
          retorno: {},
        },
        DiaSemana: '',
        FormasPagamento: [],
        TabelaTaxaKm: [],
        TipoApp: 'DELIVERY',
        Mesa: 0,
        Qs: {
          Body: '',
          Destino: 'SRVCX',
          Idloja: '',
          Origem: 'USUARIO',
          SetorCardapio: '',
          SetorTrabalho: '',
          Solicitacao: '0',
          mesa: '',
          comanda: 0,
          posicao: '',
        },
        portaria: false,
      });
    }
  }, [selected, dadosApp.Empresa.Empresa.codigo_sistema, idLoja, setDadosApp]);

  // useEffect(() => {
  //   handleGetDadosApp();
  // }, [handleGetDadosApp]);

  return (
    <>
      <BarTop />
      <Banner showStatusLoja={dadosApp.Qs.cardapioDigital !== 'true'} />
      {/* <Categorias /> */}
      {/* <MenuCategorias /> */}
      <MenuCategorias />
      {/* <MenuHeader /> */}

      {/* {!statusLoja.StatusLoja && dadosApp?.Empresa?.Config?.agendamento === 1 && <Agendamento />} */}

      <ListaProdutos />

      {modalOpcoes && (
        <Modal
          title={'Mesa ' + dadosApp.Mesa}
          isFooter={false}
          visibility={modalOpcoes ? 'block' : 'none'}
          param={{
            origin: 'modal',
            closeModal: () => setModalOpcoes(false),
          }}
          page="OPCAO_AUTO_ATENDIMENTO"
          btnOnClickClose={() => setModalOpcoes(false)}
        />
      )}
      {dadosApp.Qs.cardapioDigital !== 'true' && <SacolaBar />}
      {dadosApp.IdLoja > 0 && (
        // btnToTop
        // <Button icon="keyboard_arrow_up" className="detail_page backtotop" onClick={() => ScrollToTop()} />
        <ScrollToTop
          top={400}
          smooth
          style={{ zIndex: 9999, borderRadius: 20, bottom: 70, right: 20, background: 'rgba(0, 0, 0, 0.6)' }}
          width={20}
          height={20}
          color="white"
          component={<ScrollIcon />}
        />

        // <i className="material-icons  ">keyboard_arrow_up</i>
      )}
      <Rodape />

      <ToastContainer containerId={'toastGeral'} position="top-center" autoClose={2500} style={{ fontSize: '18px' }} />
    </>
  );
};
